const rawBaseUrl = process.env.REACT_APP_API_BASE_URL;

let baseUrl = '';
if (typeof rawBaseUrl === 'string' && rawBaseUrl.length > 0) {
  if (rawBaseUrl[rawBaseUrl.length - 1] === '/') {
    baseUrl = rawBaseUrl;
  } else {
    baseUrl = rawBaseUrl + '/';
  }
}

export const BASE_URL = baseUrl;
